import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { MeVsCompetitorsChartContainer } from "./charts/me-vs-competitors-chart";
import { MyChannelsOverview } from "./charts/my-channels-overview";
import { ShareOfChannelTrafficContainer } from "./tables/share-of-channel-traffic";
import { ShareOfWebsiteTrafficContainer } from "./tables/share-of-website-traffic";

export const ChannelsTab = () => (
    <Stack gap="32px">
        <Flex
            gap="32px"
            width="100%"
        >
            <MyChannelsOverview responsive />
            <MeVsCompetitorsChartContainer />
        </Flex>
        <ShareOfWebsiteTrafficContainer />
        <ShareOfChannelTrafficContainer />
    </Stack>
);
